import {Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {LdapUser} from '@Services/ldap/ldap/ldap-user.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormListRequesters} from '../../../../../common/services/requesters-form/requesters-form.model';
import {SubSink} from '@Common/core/utils/subsink';
import {IndividuDematService} from '../../../../../common/services/individus/individu-demat.service';
import {Individu} from '@Common/core/services';
import {FormListRequestersService} from '../../../../../common/services/requesters-form/requesters-form.service';
import {SnackBarToastyService, typeToast} from '@Common/widgets/general/snack-bar';
import {RequesterService} from '../../../../../common/services/requesters-form/requester.service';
import {Requester} from '../../../../../common/services/requesters-form/requester.model';
import {concatMap, finalize} from 'rxjs/operators';

/**
 * Modale de création ou de modification (informations) d'un membre d'une liste
 */
@Component({
  selector: 'app-requester-edit',
  templateUrl: './requester-edit.component.html',
  styleUrls: ['./requester-edit.component.scss']
})
export class RequesterEditComponent implements OnInit, OnDestroy {
  ldapUser: LdapUser;
  infoUser = '';
  listRequester: FormListRequesters;
  individuToAdd: Individu;
  saving = false;
  allReadyExist = '';
  subSink = new SubSink();
  constructor(@Inject(MAT_DIALOG_DATA) public data: { listRequester: FormListRequesters, action: 'add' | 'edit', member: Requester},
              public dialogRef: MatDialogRef<RequesterEditComponent>,
              private individuService: IndividuDematService,
              private snakeSvc: SnackBarToastyService,
              private formListRequesterSvc: FormListRequestersService,
              private requesterSvc: RequesterService) {
    this.listRequester = data.listRequester;
  }

  ngOnInit(): void {
    if (this.data?.action === 'edit') {
      this.infoUser = this.data?.member?.informations;
    }
  }
  addOrUpdateMemberList() {
    if (this.data?.action === 'add') {
      this._addMember();
    }
    if (this.data?.action === 'edit') {
      this._updateMember();
    }
  }

  /**
   * A la sélection de l'individu LDAP
   * - getOrCreate Individu
   * - vérification qu'il n'existe pas déjà dans la liste
   * @param {LdapUser} ldapUser
   */
  onSelectIndiv(ldapUser: LdapUser) {
    this.allReadyExist = '';
    let _individuToAdd: Individu;
    this.ldapUser = ldapUser;
    const uid = ldapUser.uid[0];
    this.subSink.sink = this.individuService
      .getOrCreate(uid)
      .pipe(concatMap((_ind: Individu) => {
        _individuToAdd = _ind;
        return this.formListRequesterSvc.checkRequesterInList(this.listRequester.id, _ind.user);
      }))
      .subscribe(_ret => {
        if (_ret) {
          this.allReadyExist =  `${ldapUser.displayName} existe déjà dans la liste "${this.listRequester.name}", veuillez rechercher une autre personne`;
          this.snakeSvc.toasty('Individu déjà existant', this.allReadyExist, typeToast.warning, 4000);
          this.individuToAdd = null;
        } else {
          this.allReadyExist = '';
          this.individuToAdd = _individuToAdd;
        }
      });
  }
  titlePath() {
    if (this.data?.action === 'add') {
      return 'Ajouter un membre à la liste';
    }
    return `Modifier les informations de ${this.data?.member?.user_obj?.first_name} ${this.data?.member?.user_obj?.last_name}`;
  }

  userName() {
    if (this.data?.action === 'add') {
      return `${this.ldapUser?.displayName}`;
    }
    return `${this.data?.member?.user_obj?.first_name} ${this.data?.member?.user_obj?.last_name}`;
  }
  buttonTitle() {
    if (this.data?.action === 'add') {
      return `Ajouter à la liste`;
    }
    return `Modifier les informations de ${this.userName()}`;
  }
  buttonTooltip() {
    if (this.data?.action === 'add') {
      return `Ajouter ${this.userName()} à la liste`;
    }
    return `Modifier les informations de ${this.userName()}`;
  }
  private _addMember() {
    if (this.individuToAdd) {
      this.saving = true;
      const _member = <Requester> {
        id: 0,
        active: true,
        user: this.individuToAdd.user,
        informations: this.infoUser
      };
      this.subSink.sink = this.requesterSvc
        .updateOrcreate(_member)
        .pipe(
          finalize(() => this.saving = false),
          concatMap((_requester: Requester) => this.formListRequesterSvc
            .addOrDeleteRequester('add', this.listRequester.id, _requester.id, this.infoUser)))
        .subscribe(_ => this._toastyAndClose());
    }
  }
  private _updateMember() {
    const _member = this.data?.member;
    this.saving = true;
    _member.informations = this.infoUser;
    this.subSink.sink = this.requesterSvc
      .update(_member)
      .pipe(finalize(() => this.saving = false))
      .subscribe(_ => this._toastyAndClose());
  }
  private _toastyAndClose() {
    let _message = ``;
    if (this.data?.action === 'edit') {
      _message = `Les informations de ${this.userName()} ont bien été modifiées`;
    } else {
      _message = `${this.userName()} a bien été ajouté à la liste`;
    }
    this.snakeSvc.toasty('Membre', _message, typeToast.success);
    this.dialogRef.close();
  }
  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }


}
